<div class="w-full">
    <section>
        <div class="md:mx-24 mb-18 max-sm:mx-4">
            <div class="mt-12 mb-4">
                <div class="flex flex-row pb-4 hover:cursor-pointer" routerLink="/dashboard">
                    <div class="mr-2">
                      <mat-icon svgIcon="heroicons_solid:arrow-left-circle" [color]="'primary'"></mat-icon>
                    </div>
                    <div class="font-bold">
                      Go back to dashboard
                    </div>
                  </div>
                <h1 class="md:text-4xl text-3xl font-extrabold text-primary">
                    My profile
                </h1>
                <p class="text-black text-lg">
                    View and manage your details
                </p>
            </div>
            <fuse-card class=" p-1 rounded-3xl shadow drop-shadow">
                <div class="flex flex-row w-full space-x-4">
                    <button mat-flat-button class="w-full max-sm:text-md"
                        (click)="selectButton('details')"
                        [style.background-color]="selectedButton === 'details' ? '#3f2d79': 'white'"
                        [style.color]="selectedButton === 'details' ? 'white' : 'black'">
                        My Details
                    </button>
                    <button mat-flat-button class=" w-full max-sm:text-md ml-2" 
                        (click)="selectButton('rica')"
                        [style.background-color]="selectedButton === 'rica' ? '#3f2d79': 'white'"
                        [style.color]="selectedButton === 'rica' ? 'white' : 'black'">
                        <p matBadge="!" matBadgeOverlap="true" matBadgeSize="small" [matBadgeHidden]="!uploadedProof && !uploadedId ? false : true">My RICA documents</p>
                    </button>
                    <!-- <button mat-flat-button class="w-full max-sm:text-xs ml-2"
                        (click)="selectButton('security')"
                        [style.background-color]="selectedButton === 'security' ? '#3f2d79' : 'white'"
                        [style.color]="selectedButton === 'security' ? 'white' : 'black'">
                        Account & security
                    </button> -->
                </div>
            </fuse-card>
        </div>
    </section>

    <!-- ## ACCOUNT DETAILS ## -->
    <section *ngIf="selectedButton == 'details'">
        <div class="mb-18 md:mx-24 max-sm:mx-4">
            <div>
                <h1 class='md:text-4xl text-3xl font-extrabold text-primary max-sm:mb-4'>
                    Password
                </h1>
                <p class="font-bold text-lg">
                    Your password will never be shared or displayed on your profile for any reason.
                </p>
                <hr class="mt-2">
                <button class="mt-2 text-lg font-bold bg-accent" mat-flat-button (click)="resetPassword()">
                    Reset Password
                </button>
            </div>


            
            <!-- ## ACCOUNT ## -->
            <h1 class='md:text-4xl text-3xl font-extrabold text-primary mt-20'>
                My Details
            </h1>
            <hr class="mt-2">
            <div class="flex flex-col items-center justify-center text-center space-y-12  ">
                <fuse-card class="shadow drop-shadow p-4">
                    <form class="" [formGroup]="accountForm">
                        <h1 class="text-center text-3xl font-bold mb-4">
                            Account
                        </h1>
                        <mat-form-field class="w-full rounded-2xl">
                            <mat-label class="font-bold text-lg">Name</mat-label>
                            <input id="name" class="text-xl" matInput [formControlName]="'name'">
                            <mat-error *ngIf="accountForm.invalid" class="text-lg">
                                Please enter a valid Name
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field class="w-full rounded-2xl">
                            <mat-label class="font-bold text-lg">Surname</mat-label>
                            <input id="name" class="text-xl" matInput [formControlName]="'surname'">
                            <mat-error *ngIf="accountForm.invalid" class="text-lg">
                                Please enter a valid Surname
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field class="w-full rounded-2xl">
                            <mat-label class="font-bold text-lg">Email</mat-label>
                            <input id="name" class="text-xl" matInput [formControlName]="'email'">
                            <mat-error *ngIf="accountForm.invalid" class="text-lg">
                                Please enter a valid Email
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field class="w-full rounded-2xl">
                            <mat-label class="font-bold text-lg">Phone Number</mat-label>
                            <input id="name" class="text-xl" matInput [formControlName]="'phoneNumber'">
                            <mat-error *ngIf="accountForm.invalid" class="text-lg">
                                Please enter a valid Phone Number
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field class="w-full rounded-2xl readonly-matinput">
                            <mat-label class="font-bold text-lg">ID or Passport Number</mat-label>
                            <p class="text-xl">{{displayedIdNumber}}</p>
                            <input id="name" class="text-xl hidden" matInput [formControlName]="'idNumber'" readonly>
                            <mat-error *ngIf="accountForm.invalid" class="text-lg">
                                Please enter a valid ID
                            </mat-error>
                        </mat-form-field>
                    </form>
                </fuse-card>
                <fuse-card class="shadow drop-shadow p-4">
                    <!-- ## BILLING ## -->
                    <form [formGroup]="billingForm">
                        <h1 class="text-center text-3xl font-bold mb-4">
                            Detailed Address
                        </h1>
                        <mat-form-field class="w-full rounded-lg">
                            <mat-label class="font-bold text-lg">Street Address</mat-label>
                            <input id="name" class="text-xl" matInput [formControlName]="'streetAddress'">
                            <mat-error *ngIf="accountForm.invalid" class="text-lg">
                                Please enter a Street Address
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field class="w-full rounded-lg">
                            <mat-label class="font-bold text-lg">Unit Number</mat-label>
                            <input id="name" class="text-xl" matInput [formControlName]="'unitNumber'">
                            <mat-error *ngIf="accountForm.invalid" class="text-lg">
                                Please enter a Unit Number
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field class="w-full rounded-lg">
                            <mat-label class="font-bold text-lg">Province</mat-label>
                            <mat-select class="text-xl" [formControlName]="'province'">
                              <mat-option *ngFor="let province of provinces" [value]="province">{{ province }}</mat-option>
                            </mat-select>
                            <mat-error *ngIf="accountForm.invalid" class="text-lg">
                              Please select a Province
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field class="w-full rounded-lg">
                            <mat-label class="font-bold text-lg">Country</mat-label>
                            <input id="name" class="text-xl" matInput [formControlName]="'country'">
                            <mat-error *ngIf="accountForm.invalid" class="text-lg">
                                Please enter a Country
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field class="w-full rounded-lg">
                            <mat-label class="font-bold text-lg">Postal Code</mat-label>
                            <input id="name" class="text-xl" matInput [formControlName]="'postalCode'">
                            <mat-error *ngIf="accountForm.invalid" class="text-lg">
                                Please enter a Postal Code
                            </mat-error>
                        </mat-form-field>
                    </form>
                </fuse-card>
            </div>
            <div class="flex flex-col md:mx-24">
                <hr class="mb-2">
                <div class="flex flex-row justify-end">
                    <!-- <button class="mt-2 text-lg font-bold mx-4 bg-gray-100 " mat-flat-button>
                        Cancel
                    </button> -->
                    <button class="mt-2 text-lg font-bold mx-4 bg-accent" mat-flat-button (click)="saveCustomerDetails()">
                        Save
                    </button>
                </div>
            </div>
        </div>
    </section>

    <!-- ## RICA DETAILS ## -->
    <section *ngIf="selectedButton == 'rica'">
        <div class="mx-24 mb-24  max-sm:mx-4">
            <div class="flex flex-col items-left p-3">
                <div class="self-start w-full">
                    <h1 class='text-xl font-extrabold text-black'>
                        Dear {{customerAccount?.PrimaryContactName}}, RICA is a legal requirement.
                    </h1>
                    <p class="mt-2 font-bold text-lg">
                        Please see what you need to submit below:
                    </p>
                </div>
            </div>
            <div class="flex flex-col  mt-12">
                <fuse-card class="flex  justify-start shadow drop-shadow p-4">
                    <div class="flex flex-col items-left">
                        <div class="flex flex-col items-start">
                            <mat-icon class="flex flex-col items-center">description</mat-icon>
                            <h1 class="text-xl font-bold">
                                Documents
                            </h1>
                        </div>
                        <br>
                        <p class="  font-bold">
                            To begin uploading your required documents, click the buttons below. 
                        </p>
                        <div *ngIf="documentsUploading" class="flex flex-row items-left">
                            <mat-spinner diameter="50"></mat-spinner>
                        </div>
                        <div *ngIf="!documentsUploading" class="flex flex-row items-left">
                            <button class="mt-4 text-lg font-bold bg-accent lg:w-1/2" mat-flat-button
                                (click)="fileTriggers().fileInput('uploadIdDocument')">
                                <p *ngIf="!uploadedId">
                                    Upload ID document
                                </p>
                                <p *ngIf="uploadedId">
                                    Resubmit ID document
                                </p>
                            </button>
                            <mat-icon class="mt-2" *ngIf="uploadedId">
                                check
                            </mat-icon>
                        </div>
                        <div *ngIf="!documentsUploading"  class="flex flex-row items-center">
                            <button class="mt-4 text-lg font-bold bg-accent lg:w-1/2" mat-flat-button
                                (click)="fileTriggers().fileInput('uploadProofOfResidence')">
                                <p *ngIf="!uploadedProof">
                                    Upload proof of residence
                                </p>
                                <p *ngIf="uploadedProof">
                                    Resubmit proof of residence
                                </p>
                            </button>
                            <mat-icon class="mt-2" *ngIf="uploadedProof">
                                check
                            </mat-icon>
                        </div>
                        <div class="flex flex-col mt-6 space-y-4">
                            <div class="flex flex-col items-left">
                                <h1 class="text-lg ">
                                    ID attachment:  
                                </h1>
                                <p class="font-bold text-lg">
                                    {{idFileName}}
                                </p>
                            </div>
                            <div class="flex flex-col items-left">
                                <h1 class="text-lg">
                                    Proof of residence attachment:
                                </h1>
                                <p class="font-bold text-lg">
                                    {{proofFileName}}
                                </p>
                            </div>
                        </div>
                    </div>
                 
                </fuse-card>
            </div>
            <div class="flex flex-col items-center mt-10">
                <fuse-card class="py-12 md:pr-12 md:pl-3 shadow drop-shadow w-full max-sm:p-3">
                    <div class="flex flex-col ml-3">
                        <h1 class="text-lg font-bold">In accordance with the legal requirements imposed on Internet
                            Service Providers in South Africa, it is necessary for us to verify both your identity and
                            physical address. The following criteria must be met for compliance:</h1>
                        <br>
                        <p class="mt-2 font-normal text-lg">
                            <span class="font-bold">The Requirements are:</span>
                            <br>
                            <br>
                            · Scanned copy of your green barcode ID book, ID card, or equivalent if you are a foreigner.
                            <br>
                            · A document for proof of residence containing your physical address (not postal).<br>
                            <br>
                            <span class="font-bold">
                                Valid proof of address documents are:
                            </span>
                            <br>
                            <br>
                            · A bank statement, or municipal bill.<br>
                            · A cellphone or retail account.<br>
                            · A rental.credit or lease agreement.<br>
                            · An insurance policy cover document.<br>
                            · A television, or motor vehicle document.<br>
                            · Informal settlements: A letter from a school, church or store where you receive post.<br>
                            <br>
                            <span class="font-bold">The document must contain your physical address and not be older
                                than three months.</span>
                        </p>
                    </div>
                </fuse-card>
            </div>
          
        </div>
    </section>

    <!-- ## Account & Security DETAILS ## -->
    <!-- <section *ngIf="selectedButton == 'security'">
        <div class="md:mx-24 mb-24 flex flex-col space-y-32 max-sm:mx-4 ">
        
            <div class="flex flex-col">
                <div class="self-start w-full">
                    <h1 class='md:text-4xl text-3xl font-extrabold text-primary max-sm:mb-4'>
                        Two-factor authentication
                    </h1>
                    <p class="font-bold text-lg">
                        We strongly recommend enabling two-factor authentication to enhance the security of your account. 
                    </p>
                    <hr class="mt-2">
                </div>

                <div class="flex-col flex">
                    <p class="font-extrabold text-xl">
                        One time pin 
                    </p>
                    <p class="font-medium text-lg w-3/4 max-sm:w-full">
                        After entering your email address, you will receive a One Time Pin (OTP) that you can use to secure your account. 
                    </p>
                    <p class="font-bold text-lg mt-6">Enable Two Factor Authentication<mat-slide-toggle color="black"
                            class="ml-4"> </mat-slide-toggle></p>
                </div>
            </div>
            <div class="flex flex-col items-center">
                <div class="self-start w-full">
                    <h1 class='md:text-4xl text-3xl font-extrabold text-primary max-sm:mb-4'>
                        Data management
                    </h1>
                    <p class="font-bold text-lg">
                        Manage your personal data
                    </p>
                    <hr class="mt-2">
                </div>

                <div class="flex md:flex-row items-center flex-col">
                    <div class="flex-col flex">
                        <p class="font-bold text-lg">
                            Request account closure
                        </p>
                        <p class="font-medium text-lg md:w-3/4">
                            If you want to delete your personal data from our website, click “Close account”. Please note that this action is permanent and cannot be undone. A Supersonic agent will be in touch.
                        </p>
                    </div>
                    <button class="mt-2 text-lg font-bold bg-white border-solid border-black rounded-full max-sm:mt-8" mat-flat-button>
                        Close Account
                    </button>
                </div>
            </div>
        </div>
    </section> -->
</div>
<input type="file" id="uploadIdDocument" (change)="fileTriggers().onFileSelected($event, 'IDDOCUMENT')" hidden />
<input type="file" id="uploadProofOfResidence" (change)="fileTriggers().onFileSelected($event, 'PROOFOFRESIDENCE')"
    hidden />